function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
var OurPurposeCounter = function OurPurposeCounter(_ref) {
  var onPageChange = _ref.onPageChange;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    page = _useState2[0],
    setPage = _useState2[1];
  var _useState3 = useState(0 * 850),
    _useState4 = _slicedToArray(_useState3, 2),
    counter = _useState4[0],
    setCounter = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    timer = _useState6[0],
    setTimer = _useState6[1];
  var pageTime = 850;
  var maxTime = 11 * pageTime;
  useEffect(function () {
    $(document).on('reset', function () {
      return setCounter(0);
    });
    return function () {
      clearTimeout(timer);
      $(document).off('reset', function () {
        return setCounter(0);
      });
    };
  }, []);
  useEffect(function () {
    onPageChange(page);
  }, [page]);
  useEffect(function () {
    if (timer) clearTimeout(timer);
    if (counter < maxTime - 1) {
      if (Math.floor(counter / pageTime) !== page) setPage(Math.floor(counter / pageTime));
      setTimer(setTimeout(function () {
        setCounter(counter === maxTime - 1 ? 0 : counter + 1);
      }, 10));
    }
  }, [counter]);

  // console.log('page', page);

  return /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement("div", {
    className: "counter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "counter__body"
  }, [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(function (x) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dot, {
      nr: x,
      page: page,
      pageTime: pageTime,
      onClick: function onClick(counter) {
        return setCounter(counter);
      }
    }), x !== 10 && /*#__PURE__*/React.createElement(Progress, {
      nr: x,
      counter: counter,
      pageTime: pageTime
    }));
  }))), document.getElementById('root'));
};
export default OurPurposeCounter;
var Progress = function Progress(_ref2) {
  var nr = _ref2.nr,
    counter = _ref2.counter,
    pageTime = _ref2.pageTime;
  var time = counter - nr * pageTime;
  if (time < 0) time = 0;
  var progress = time / pageTime;
  if (progress > 1) progress = 1;
  return /*#__PURE__*/React.createElement("div", {
    className: "counter__bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "counter__bar--track"
  }), /*#__PURE__*/React.createElement("div", {
    className: "counter__bar--progress",
    style: {
      width: "".concat(progress * 100, "%")
    }
  }));
};
var Dot = function Dot(_ref3) {
  var nr = _ref3.nr,
    page = _ref3.page,
    pageTime = _ref3.pageTime,
    _onClick = _ref3.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: ['counter__dot', page >= nr ? 'counter__dot--active' : ''].join(' '),
    onClick: function onClick() {
      _onClick(nr * pageTime);
    }
  });
};